/**
 * Location display utilities
 *
 * Provides helpers for styling location text based on its source.
 * Omni GPS locations render in purple to distinguish from
 * Starlink-derived or manually-set locations.
 */

/**
 * Returns the CSS class for location text based on its source.
 * Omni GPS → purple, everything else → default.
 */
export function getLocationTextClass(locationSource?: string | null): string {
  if (locationSource === 'omni') return 'text-purple-400';
  return '';
}
